import type {MeterTone} from "./creditsWidgetState.ts";

export const RING_SIZE = "44px";
export const RING_THICKNESS = "8px";
export const tabularNums = {fontVariantNumeric: "tabular-nums"} as const;
export const focusRing = {outline: "2px solid", outlineColor: "brandPurple.500", outlineOffset: "2px"} as const;
export const METER_COLORS: Record<MeterTone, string> = {
  plan: "brandPurple.500",
  warning: "sunsetAmber.500",
  neutral: "n.400",
};

// DESIGN.md motion: 120ms press scale, 200ms color fades; reduced motion keeps only the fades.
export const pressTransition = {
  transition: "transform 120ms cubic-bezier(0.2, 0, 0, 1), background-color 200ms linear, border-color 200ms linear",
  _mediaReduceMotion: {transition: "background-color 200ms linear, border-color 200ms linear"},
} as const;

export const filledCtaStyle = {
  ...pressTransition,
  colorScheme: "purple",
  bg: "brandPurple.500",
  color: "white",
  _hover: {bg: "violetPurple.500"},
  _active: {bg: "brandPurple.600", transform: "scale(0.96)"},
} as const;

// Grows a 32px control to a 40px pointer target; the 8px gaps around it keep it clear of its neighbours.
export const ctaHitArea = {content: '""', position: "absolute", insetX: 0, insetY: "-4px"} as const;

// The top block is one target: a wash on hover, a deeper one while pressed; a block this large never scales.
export const blockWash = {
  transition: "background-color 200ms linear",
  _hover: {bg: "n.600"},
  _active: {bg: "n.500"},
} as const;

export const ringPress = {
  transition: "transform 120ms cubic-bezier(0.2, 0, 0, 1)",
  _active: {transform: "scale(0.96)"},
  _mediaReduceMotion: {transition: "none"},
} as const;
